import { BREADCRUMB_PREFERRED_ALIAS_SET, BREADCRUMB_PREFERRED_ALIAS_CLEAR } from './breadcrumbNavigationConstants';

export type BreadcrumbPreferredAliasSetAction = {
    type: typeof BREADCRUMB_PREFERRED_ALIAS_SET;
    boardId: string;
    aliasId: string;
};

export type BreadcrumbPreferredAliasClearAction = {
    type: typeof BREADCRUMB_PREFERRED_ALIAS_CLEAR;
    boardId: string;
};

export type BreadcrumbNavigationAction = BreadcrumbPreferredAliasSetAction | BreadcrumbPreferredAliasClearAction;

export const breadcrumbPreferredAliasSet = ({
    boardId,
    aliasId,
}: {
    boardId: string;
    aliasId: string;
}): BreadcrumbPreferredAliasSetAction => ({
    type: BREADCRUMB_PREFERRED_ALIAS_SET,
    boardId,
    aliasId,
});

export const breadcrumbPreferredAliasClear = ({
    boardId,
}: {
    boardId: string;
}): BreadcrumbPreferredAliasClearAction => ({
    type: BREADCRUMB_PREFERRED_ALIAS_CLEAR,
    boardId,
});
